import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';
import './AdminNavbar.css';

const AdminNavbar = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isAdmin, setIsAdmin] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const fetchAdminUser = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      handleLogout();
      return;
    }
    
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/authorize`, {
        headers: { Authorization: `Bearer ${token}` },
      });


      if (!response.data.isAdmin) {
        handleLogout();
      } else {
        setIsAdmin(true);
      }
      
    } catch (error) {
      if (error.response && error.response.status === 401) {
        handleLogout();
      } else {
        console.error('Error fetching user info:', error);
      }
    }
  };

  useEffect(() => {
    fetchAdminUser();
  }, []);

  if (!isAdmin) return null;

  return (
    <div className="admin-navbar" style={{ height: '64px' }}>
      <div className="nav-tabs">
        <NavLink 
          to="/admin/dashboard" 
          className={({ isActive }) => isActive ? 'active' : ''}
          onClick={() => setActiveTab('dashboard')}
        >
          Dashboard
        </NavLink>
        <NavLink 
          to="/admin/admins" 
          className={({ isActive }) => isActive ? 'active' : ''}
          onClick={() => setActiveTab('admins')}
        >
          Admins
        </NavLink>
        <NavLink 
          to="/admin/organizations" 
          className={({ isActive }) => isActive ? 'active' : ''}
          onClick={() => setActiveTab('organizations')}
        >
          Organizations
        </NavLink>
        <NavLink 
          to="/admin/settings" 
          className={({ isActive }) => isActive ? 'active' : ''}
          onClick={() => setActiveTab('settings')}
        >
          Settings
        </NavLink>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminNavbar;